import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getMstaddresstype,
  getIdMstaddresstype,
  createMstaddresstype,
  updateMstaddresstype,
  deleteMstaddresstype,
  getLocationMaster,
  getIdLocationMaster,
  createLocationMaster,
  updateLocationMaster,
  deleteLocationMaster,
  getCountry,
  getIdCountry,
  createCountry,
  updateCountry,
  deleteCountry,
} from "./locationAPI";

const initialState = {
  data: [],
  dataId: null,
  dataLocation: [],
  dataIdLocation: null,
  dataCountry: [],
  dataCountryAll: [],
  dataIdCountry: null,
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  pageNoAddres: 1,
  pageSizeAddres: 10,
  totalRecordAddres: 0,
  pageNoLocation: 1,
  pageSizeLocation: 10,
  totalRecordLocation: 0,
  selected: null,
  result: null,
  permissionAddress: [],
  permissionCountry: [],
  permissionLocationMaster: [],
};

export const fetchMstaddresstype = createAsyncThunk(
  "Mstaddresstype/fetchMstaddresstype",
  async (payload) => {
    const response = await getMstaddresstype(payload);
    return response;
  }
);

export const addMstaddresstype = createAsyncThunk(
  "Mstaddresstype/addMstaddresstype",
  async (payload) => {
    const response = await createMstaddresstype(payload);
    return response;
  }
);

export const editMstaddresstype = createAsyncThunk(
  "Mstaddresstype/editMstaddresstype",
  async (payload) => {
    const response = await updateMstaddresstype(payload);
    return response;
  }
);

export const fetchIdMstaddresstype = createAsyncThunk(
  "Mstaddresstype/fetchIdMstaddresstype",
  async (id) => {
    const response = await getIdMstaddresstype(id);
    return response;
  }
);

export const removeMstaddresstype = createAsyncThunk(
  "Mstaddresstype/removeMstaddresstype",
  async (payload) => {
    const response = await deleteMstaddresstype(payload);
    return response;
  }
);

// location master

export const fetchLocationMaster = createAsyncThunk(
  "LocationMaster/fetchLocationMaster",
  async (payload) => {
    const response = await getLocationMaster(payload);
    return response;
  }
);

export const addLocationMaster = createAsyncThunk(
  "LocationMaster/addLocationMaster",
  async (payload) => {
    const response = await createLocationMaster(payload);
    return response;
  }
);

export const editLocationMaster = createAsyncThunk(
  "LocationMaster/editLocationMaster",
  async (payload) => {
    const response = await updateLocationMaster(payload);
    return response;
  }
);

export const fetchIdLocationMaster = createAsyncThunk(
  "LocationMaster/fetchIdLocationMaster",
  async (id) => {
    const response = await getIdLocationMaster(id);
    return response;
  }
);

export const removeLocationMaster = createAsyncThunk(
  "LocationMaster/removeLocationMaster",
  async (payload) => {
    const response = await deleteLocationMaster(payload);
    return response;
  }
);

// Country

export const fetchCountry = createAsyncThunk(
  "Country/fetchCountry",
  async (payload) => {
    const response = await getCountry(payload);
    return response;
  }
);

export const fetchCountryAll = createAsyncThunk(
  "Country/fetchCountryAll",
  async (payload) => {
    const response = await getCountry(payload);
    return response;
  }
);

export const addCountry = createAsyncThunk(
  "Country/addCountry",
  async (payload) => {
    const response = await createCountry(payload);
    return response;
  }
);

export const editCountry = createAsyncThunk(
  "Country/editCountry",
  async (payload) => {
    const response = await updateCountry(payload);
    return response;
  }
);

export const fetchIdCountry = createAsyncThunk(
  "Country/fetchIdCountry",
  async (id) => {
    const response = await getIdCountry(id);
    return response;
  }
);

export const removeCountry = createAsyncThunk(
  "Country/removeCountry",
  async (payload) => {
    const response = await deleteCountry(payload);
    return response;
  }
);

export const locationSlice = createSlice({
  name: "location",
  initialState,
  reducers: {
    resetData: () => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
    setPermissionAddress: (state, action) => {
      state.permissionAddress = action.payload;
    },
    setPermissionCountry: (state, action) => {
      state.permissionCountry = action.payload;
    },
    setPermissionLocationMaster: (state, action) => {
      state.permissionLocationMaster = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMstaddresstype.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMstaddresstype.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNoAddres = action.payload.data.pageNo;
        state.pageSizeAddres = action.payload.data.pageSize;
        state.totalRecordAddres = action.payload.data.totalRecord;
      })
      .addCase(fetchIdMstaddresstype.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchIdMstaddresstype.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })

      .addCase(addMstaddresstype.pending, (state) => {
        state.loading = true;
      })
      .addCase(addMstaddresstype.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })

      .addCase(editMstaddresstype.pending, (state) => {
        state.loading = true;
      })
      .addCase(editMstaddresstype.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })

      .addCase(removeMstaddresstype.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeMstaddresstype.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      //  location

      .addCase(fetchLocationMaster.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchLocationMaster.fulfilled, (state, action) => {
        state.loading = false;
        state.dataLocation = action.payload.data.data;
        state.pageNoLocation = action.payload.data.pageNo;
        state.pageSizeLocation = action.payload.data.pageSize;
        state.totalRecordLocation = action.payload.data.totalRecord;
      })
      .addCase(fetchIdLocationMaster.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchIdLocationMaster.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })

      .addCase(addLocationMaster.pending, (state) => {
        state.loading = true;
      })
      .addCase(addLocationMaster.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })

      .addCase(editLocationMaster.pending, (state) => {
        state.loading = true;
      })
      .addCase(editLocationMaster.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })

      .addCase(removeLocationMaster.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeLocationMaster.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      //  Country

      .addCase(fetchCountry.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCountry.fulfilled, (state, action) => {
        state.loading = false;
        state.dataCountry = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
      })

      .addCase(fetchCountryAll.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCountryAll.fulfilled, (state, action) => {
        state.loading = false;
        state.dataCountryAll = action.payload.data.data;
      })
      .addCase(fetchIdCountry.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchIdCountry.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })

      .addCase(addCountry.pending, (state) => {
        state.loading = true;
      })
      .addCase(addCountry.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })

      .addCase(editCountry.pending, (state) => {
        state.loading = true;
      })
      .addCase(editCountry.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })

      .addCase(removeCountry.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeCountry.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      });
  },
});

export const {
  resetData,
  setSelected,
  setPermissionAddress,
  setPermissionCountry,
  setPermissionLocationMaster,
} = locationSlice.actions;

export const selectMstaddresstype = (state) => state.location.data;
export const selectIdMstaddresstype = (state) => state.location.dataId;
export const selectLocationMaster = (state) => state.location.dataLocation;
export const selectIdLocationMaster = (state) => state.location.dataIdLocation;
export const selectCountry = (state) => state.location.dataCountry;
export const selectCountryAll = (state) => state.location.dataCountryAll;
export const selectIdCountry = (state) => state.location.dataIdCountry;
export const selectLoading = (state) => state.location.loading;
export const selectError = (state) => state.location.error;
export const selectPageNo = (state) => state.location.pageNo;
export const selectPageSize = (state) => state.location.pageSize;
export const selectTotalRecord = (state) => state.location.totalRecord;
export const selectPageNoAddress = (state) => state.location.pageNoAddres;
export const selectPageSizeAddress = (state) => state.location.pageSizeAddres;
export const selectTotalRecordAddress = (state) => state.location.totalRecordAddres;
export const selectPageNoLocation = (state) => state.location.pageNoLocation;
export const selectPageSizeLocation = (state) => state.location.pageSizeLocation;
export const selectTotalRecordLocation = (state) => state.location.totalRecordLocation;
export const selectSelected = (state) => state.location.selected;
export const selectResult = (state) => state.location.result;
export const selectPermissionAddress = (state) =>
  state.location.permissionAddress;
export const selectPermissionCountry = (state) =>
  state.location.permissionCountry;
export const selectPermissionLocationMaster = (state) =>
  state.location.permissionLocationMaster;

export default locationSlice.reducer;
